import Image from "next/image";
import React from "react";
import AspectRatioComponent from "~/components/aspect-ratio";
import GlowingButton from "~/components/reusables/glowing-button";
import OutlineButton from "~/components/reusables/outline-button";
import { LinkTrackers } from "~/components/reusables/link-trackers";
import Link from "next/link";

export const BlogDownloadable = ({ downloadable, ctaBtn, dark = true }) => {
  if (!downloadable) return null;
  const isGatedAsset = downloadable.fileType === "Gated Asset";

  return (
    <div className={dark ? "bg-black" : "bg-white"}>
      <div className="relative my-[80px] overflow-hidden md:container">
        <div className='container relative overflow-hidden rounded-lg border border-white bg-black bg-cover bg-center py-14 lg:bg-[url("https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/downloadable-bg.svg")]'>
          <div className='absolute right-0 top-[8px] z-0 h-[380px] w-full overflow-hidden bg-[url("https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/collection-bg.png")] bg-cover sm:w-[630px] lg:hidden  '></div>
          <div className="absolute right-0 top-[8px] z-20 h-[380px] w-full bg-gradient-to-tr from-black via-[#000000c0] to-[#fff0] sm:w-[630px] lg:hidden"></div>
          <div className='absolute bottom-0 left-0 z-0 h-[280px] w-[430px] bg-[url("https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/downloadable-bg-bottom.svg")] bg-cover lg:hidden  '></div>
          <div className="absolute bottom-0 left-0 z-20 h-[280px] w-[430px] bg-gradient-to-bl from-black via-[#000000c0] to-[#fff0] lg:hidden"></div>
          <div className="absolute left-0 top-0 h-[8px] w-full rounded-t-lg bg-gradient-blue-purple"></div>
          <div className="relative z-40 flex flex-col items-center md:gap-[100px] lg:flex-row">
            <div className="flex flex-col md:flex-1">
              <h3 className="font-hero-title md:font-h1 lg:font-h3 text-white">
                {downloadable.header}
              </h3>
              <p className="font-p py-10 text-white md:bg-gradient-to-b md:from-black md:to-[#00000000]">
                {downloadable.description}
              </p>
              <div className="flex flex-row gap-5 lg:flex-col xl:flex-row">
                {ctaBtn && (
                  <div className="hidden md:block">
                    <OutlineButton variant="dark">
                      <Link
                        href={ctaBtn?.url}
                        target={ctaBtn?.external ? "_blank" : "_self"}
                        className="font-btn-lg px-auto py-3 md:px-5 "
                      >
                        {ctaBtn?.cta}
                      </Link>
                    </OutlineButton>
                  </div>
                )}
                <div className="hidden md:block">
                  <GlowingButton>
                    <LinkTrackers
                      href={
                        isGatedAsset
                          ? downloadable?.cta?.url
                          : downloadable.file[0].url
                      }
                      target={
                        (isGatedAsset
                          ? downloadable?.cta?.url
                          : downloadable.file[0].url
                        )?.startsWith("/")
                          ? "_self"
                          : "_blank"
                      }
                      className="font-btn-lg px-auto py-3 md:px-5 "
                      segmentMsg="Downloadable clicked"
                      segmentOpt={
                        downloadable.trackingMsg
                          ? downloadable.trackingMsg
                          : {
                              link_label: downloadable.cta.cta,
                              location: "body",
                              resource_interaction: "read a PDF",
                              file_name: downloadable.header,
                              is_gated_asset: "false",
                            }
                      }
                    >
                      {downloadable.cta.cta}
                    </LinkTrackers>
                  </GlowingButton>
                </div>
              </div>
              {!isGatedAsset && (
                <p className="font-p-sm hidden pt-6 italic text-white md:block">
                  * No email required
                </p>
              )}
            </div>
            <div className="w-full flex-1 md:flex-[.9]">
              <AspectRatioComponent
                aspectRatio={{
                  width: downloadable?.image.width,
                  height: downloadable?.image.height,
                }}
              >
                <Image
                  unoptimized
                  src={downloadable?.image.url}
                  fill
                  alt="thumbnail"
                  className="w-[90%] object-cover"
                  sizes="100%"
                />
              </AspectRatioComponent>
            </div>
          </div>
          <div className="relative z-40 flex flex-col items-end justify-end gap-3 pt-6 md:hidden">
            {ctaBtn && (
              <div className="flex">
                <OutlineButton variant="dark">
                  <Link
                    href={ctaBtn?.url}
                    target="_blank"
                    className="font-btn-lg px-4 py-3 md:px-5 "
                  >
                    {ctaBtn?.cta}
                  </Link>
                </OutlineButton>
              </div>
            )}
            <div className="flex">
              <GlowingButton>
                <LinkTrackers
                  href={
                    isGatedAsset
                      ? downloadable?.cta?.url
                      : downloadable.file[0].url
                  }
                  target={
                    (isGatedAsset
                      ? downloadable?.cta?.url
                      : downloadable.file[0].url
                    )?.startsWith("/")
                      ? "_self"
                      : "_blank"
                  }
                  segmentMsg="Downloadable clicked"
                  segmentOpt={{
                    file_name: downloadable.header,
                    is_gated_asset: "false",
                  }}
                >
                  {downloadable.cta.cta}
                </LinkTrackers>
              </GlowingButton>
            </div>
          </div>
          {!isGatedAsset && (
            <p className="font-p-sm relative z-30 pt-6 text-right italic text-white md:hidden">
              * No email required
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
